
      import { initializeApp } from "./main.js";

      // Initialiser l'application
      initializeApp();
    